import React, { Fragment, useEffect, useState } from "react";
import SidebarWrapper from "./sidebar.style";
import Radium from "radium";
import NavList from "./NavList";
import { sidebarData } from "utils/data/sidebar";
import { adminSidebarData } from "utils/data/adminSidebar";
import { logoName } from "utils/constants";
import logoWhite from "assets/images/logo_nova_4d_azul.png";
import { Scrollbars } from "react-custom-scrollbars";
import { NavLink, useLocation } from "react-router-dom";
import IntlMessages from "utils/intlMessages";
import "bootstrap-icons/font/bootstrap-icons.css";
import { compose } from "redux";
import { connect } from "react-redux";
import AuthActions from "store/auth/actions";
import api from "api";

const { logout } = AuthActions;

const Sidebar = props => {
  const location = useLocation();
  const {
    mini,
    drawerWidth,
    miniDrawerWidth,
    onMouseEnter,
    onMouseLeave,
    sidebarTheme,
    layoutTheme,
    closeDrawer,
    themeSetting,
    token
  } = props;

  const [isAdmin, setIsAdmin] = useState(() => {
    try {
      const cached = sessionStorage.getItem("sidebar_is_admin");
      return cached === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const CACHE_KEY = "sidebar_is_admin";
    const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

    if (!token) {
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem(`${CACHE_KEY}_ts`);
      setIsAdmin(false);
      return;
    }

    const checkAdminStatus = async () => {
      try {
        const cachedTs = sessionStorage.getItem(`${CACHE_KEY}_ts`);
        if (cachedTs) {
          const ts = parseInt(cachedTs, 10);
          if (Date.now() - ts < CACHE_TTL_MS) {
            const val = sessionStorage.getItem(CACHE_KEY);
            if (val !== null) {
              setIsAdmin(val === "true");
              return;
            }
          }
        }
        const response = await api.get("/users/logged", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const admin = !!response.data.is_admin;
        setIsAdmin(admin);
        sessionStorage.setItem(CACHE_KEY, String(admin));
        sessionStorage.setItem(`${CACHE_KEY}_ts`, String(Date.now()));
      } catch (error) {
        console.error("Erro ao verificar status de administrador:", error);
        setIsAdmin(false);
        sessionStorage.removeItem(CACHE_KEY);
        sessionStorage.removeItem(`${CACHE_KEY}_ts`);
      }
    };

    if (token) {
      checkAdminStatus();
    }
  }, [token]);

  let listNameStyle;
  let logoNameStyle;
  let sidebar;
  let sideScrollStyle;

  // Estilo da barra lateral com base no layout
  if (
    themeSetting.toolbarAlignValue === "above" &&
    themeSetting.footerAlignValue === "above"
  ) {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 190px)"
    };
  } else if (themeSetting.toolbarAlignValue === "above") {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 145px)"
    };
  } else if (themeSetting.footerAlignValue === "above") {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 128px)"
    };
  } else {
    sideScrollStyle = {
      zIndex: 5,
      height: "calc(100vh - 75px)"
    };
  }

  // Estilo de transparência da sidebar
  if (themeSetting.sidebarTransParentValue === "on") {
    sidebar = {
      background: "linear-gradient(180deg, #071020 0%, #0c1a2e 100%)",
      backgroundRepeat: "no-repeat, repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      width: mini ? miniDrawerWidth : drawerWidth
    };
  } else {
    sidebar = {
      width: mini ? miniDrawerWidth : drawerWidth,
      background: "#0c1a2e",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "100vh"
    };
  }

  // Estilo de nome da lista
  if (mini) {
    listNameStyle = {
      opacity: miniDrawerWidth === drawerWidth ? 1 : 0,
      transform:
        miniDrawerWidth === drawerWidth
          ? "translateZ(0)"
          : "translate3d(-25px,0,0)"
    };
    logoNameStyle = {
      opacity: miniDrawerWidth === drawerWidth ? 1 : 0,
      transition: "opacity 0.15s linear"
    };
  } else {
    listNameStyle = {
      opacity: !mini ? 1 : 0,
      transform: !mini ? "translateZ(0)" : "translate3d(-25px,0,0)"
    };
    logoNameStyle = {
      opacity: !mini ? 1 : 0,
      transition: "opacity 0.15s linear"
    };
  }

  return (
    <>
      <SidebarWrapper
        themeSetting={themeSetting}
        sidebarTheme={sidebarTheme}
        layoutTheme={layoutTheme}
        mini={mini}
        miniDrawerWidth={miniDrawerWidth}
        drawerWidth={drawerWidth}
      >
        <div
          id="sidebar"
          className="sidebar sideBack"
          style={sidebar}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <div className="parent">
            <div className="sidebar-header ">
              <NavLink to={"/"} className="simple-text logo-mini">
                <div>
                  <img src={logoWhite} alt="Vertex 4D" />
                </div>
              </NavLink>
              <div className="logo-name simple-text" style={logoNameStyle}>
                <img src={logoName} alt="Logo" />
              </div>
            </div>

            <Scrollbars
              autoHide
              style={sideScrollStyle}
              renderThumbVertical={({ style, ...props }) => (
                <div {...props} className="sidebar-scrollbar-style" />
              )}
              renderThumbHorizontal={({ style, ...props }) => (
                <div {...props} />
              )}
              renderTrackVertical={({ style, ...props }) => (
                <div
                  {...props}
                  style={{
                    ...style,
                    zIndex: 5,
                    position: "absolute",
                    width: "6px",
                    right: "2px",
                    bottom: "2px",
                    top: "2px",
                    borderRadius: "3px"
                  }}
                />
              )}
            >
              <div className="sidebar-wrapper h-auto">
                <ul className="nav">
                  {sidebarData.map((list, i) => {
                    return (
                      <Fragment key={i}>
                        {list.type && list.type === "heading" ? (
                          (!mini || miniDrawerWidth === drawerWidth) && (
                            <div className="sidelist-header-name">
                              <Fragment>
                                <IntlMessages id={list.name} />
                                {list.hasOwnProperty("isNew") && list["isNew"] && (
                                  <span
                                    style={{
                                      right: "23px"
                                    }}
                                    className="new-update-tag fs-13 bold-text"
                                  >
                                    New
                                  </span>
                                )}
                              </Fragment>
                            </div>
                          )
                        ) : (
                          <NavList
                            listNameStyle={listNameStyle}
                            list={list}
                            mini={mini}
                            miniDrawerWidth={miniDrawerWidth}
                            drawerWidth={drawerWidth}
                            onClick={closeDrawer}
                            location={location}
                            {...props}
                          />
                        )}
                      </Fragment>
                    );
                  })}
                </ul>

                {isAdmin && (
                  <ul className="nav">
                    {adminSidebarData.map((list, i) => {
                      return (
                        <Fragment key={i}>
                          {list.type && list.type === "heading" ? (
                            (!mini || miniDrawerWidth === drawerWidth) && (
                              <div className="sidelist-header-name">
                                <Fragment>
                                  <IntlMessages id={list.name} />
                                  {list.hasOwnProperty("isNew") &&
                                    list["isNew"] && (
                                      <span
                                        style={{
                                          right: "23px"
                                        }}
                                        className="new-update-tag fs-13 bold-text"
                                      >
                                        New
                                      </span>
                                    )}
                                </Fragment>
                              </div>
                            )
                          ) : (
                            <NavList
                              listNameStyle={listNameStyle}
                              list={list}
                              mini={mini}
                              miniDrawerWidth={miniDrawerWidth}
                              drawerWidth={drawerWidth}
                              onClick={closeDrawer}
                              location={location}
                              {...props}
                            />
                          )}
                        </Fragment>
                      );
                    })}
                  </ul>
                )}
              </div>
            </Scrollbars>

            <div className="sidebar-button w-100">
              {/* Suporte via WhatsApp – destaque */}
              <div
                className={`sidebar-whatsapp-block ${mini ? "sidebar-whatsapp-block--mini" : ""}`}
                title="Fale conosco pelo WhatsApp"
              >
                {!mini && (
                  <div className="sidebar-whatsapp-label">
                    <span className="sidebar-whatsapp-title">Precisa de Ajuda?</span>
                    <span className="sidebar-whatsapp-subtitle">Fale conosco!</span>
                  </div>
                )}
                <a
                  href="https://wa.me/5571996901891?text=Ol%C3%A1%2C%0ASou%20usu%C3%A1rio%20do%20Vertex%204D!"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sidebar-whatsapp-link"
                >
                  <button type="button" className="sidebar-whatsapp-btn variant-hover">
                    <i className="fab fa-whatsapp fa-2x sidebar-whatsapp-icon" />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </SidebarWrapper>
    </>
  );
};

const mapStateToProps = state => ({
  token: state.auth.accessToken
});

export default compose(connect(mapStateToProps, { logout }))(Radium(Sidebar));
